var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2492 16.264L10.0328 8.9539L17.486 1.73597C17.7579 1.46403 17.7579 1.02264 17.4867 0.749967C17.214 0.476624 16.7726 0.477327 16.5 0.749264L9.04546 7.9686L1.73668 0.749291C1.46404 0.477355 1.02265 0.476652 0.750007 0.749995C0.478071 1.02263 0.47807 1.46403 0.75071 1.736L8.05812 8.9539L0.751413 16.264C0.478774 16.5359 0.478774 16.9773 0.75071 17.25C0.886696 17.3866 1.06589 17.4543 1.24442 17.4543C1.42294 17.4543 1.60143 17.3859 1.73742 17.2507L9.04549 9.93916L16.2633 17.2507C16.3993 17.3866 16.5778 17.4543 16.7563 17.4543C16.9348 17.4543 17.114 17.3859 17.25 17.25C17.5219 16.9773 17.5219 16.5359 17.2492 16.264Z",
    fill: "#1B80C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close_icon.681707c1046ea10e76f2e89bcaba6471.svg";
export { ForwardRef as ReactComponent };